<script lang="ts" setup>
import ProductCard from '~/components/cards/ProductCard.vue'
import ProductSort from '~/components/dropdown-menus/ProductSort.vue'
import type ProductSortEnum from '~/enums/product-sort'
import type { Page } from '~/types/json-api'
import type { ProductData } from '~/types/products'

const sort = defineModel<ProductSortEnum>('sort')

withDefaults(
  defineProps<{
    noProductsText?: string
    page: Page
    productsData: ProductData[]
    query?: string | null
    totalPages: number | null
  }>(),
  { noProductsText: 'Нет товаров.', query: null }
)

const emit = defineEmits<{
  (e: 'changePage', x: number): void
  (e: 'removeProductFromList', x: string): void
}>()
</script>

<template>
  <div>
    <div id="scroll-anchor" />

    <section class="my-6">
      <div class="container">
        <ProductSort v-if="productsData.length" v-model="sort" />
      </div>
    </section>

    <section v-if="(totalPages ?? 0) > 1" class="mb-6">
      <div class="container">
        <Pagination
          :current-page="page.number"
          :is-on-white-background="false"
          :last-page="totalPages"
          @change-page="(x: number): void => emit('changePage', x)"
        />
      </div>
    </section>

    <section v-if="productsData.length">
      <div class="container">
        <div class="-m-1 flex flex-wrap xl:-m-2">
          <div v-for="x in productsData" :key="x.id" class="w-1/2 p-1 md:w-1/3 md:p-2 xl:w-1/5">
            <ProductCard
              :product-data="x"
              @remove-product-from-list="(x: string): void => emit('removeProductFromList', x)"
            />
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <div class="container">
        <div class="content-wrapper">
          <Notification status="info">
            {{ query ? 'Товары не\xA0найдены.' : noProductsText }}
          </Notification>
        </div>
      </div>
    </section>

    <section v-if="(totalPages ?? 0) > 1" class="mt-6">
      <div class="container">
        <Pagination
          :current-page="page.number"
          has-next-button
          :is-on-white-background="false"
          :last-page="totalPages"
          @change-page="(x: number): void => emit('changePage', x)"
        />
      </div>
    </section>
  </div>
</template>
